<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_ix"></a><a id="map"></a><img alt="image" src="html/images/f00ix-01.gif"/></p>
<p class="fcaption"><em>Map of the Vilcabamba, the region in which Hiram Bingham searched for the last cities of the Incas between 1909 and 1915. (Map by Emily Davis Adams)</em></p>
<p class="image"><a id="page_x"></a><img alt="image" src="html/images/f000x-01.gif"/></p>
<p class="fcaption"><em>South America, 1909, the scene of Hiram Bingham’s great successes and failures. (Map by Emily Davis Adams)</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230337411_08_map.vue?61a93755